import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Detect if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);
  return <>
      <section className="relative w-full bg-black min-h-[100vh] py-12 overflow-hidden" data-id="element-68">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden bg-black" data-id="element-69">
          <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-70">
            {isMobile ? <iframe src="https://player.vimeo.com/video/1128094568?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1" allow="autoplay; fullscreen" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100vw',
            height: '100vh',
            minWidth: '100%',
            minHeight: '100%',
            transform: 'translate(-50%, -50%) scale(1.5)',
            objectFit: 'cover',
            zIndex: -1,
            border: 'none'
          }} title="Mobile Wall Street Background Video" data-id="element-71"></iframe> : <iframe src="https://player.vimeo.com/video/1127157880?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1" allow="autoplay; fullscreen" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100vw',
            height: '100vh',
            minWidth: '100%',
            minHeight: '100%',
            transform: 'translate(-50%, -50%) scale(1.5)',
            objectFit: 'cover',
            zIndex: -1,
            border: 'none'
          }} title="Wall Street Background Video" data-id="element-72"></iframe>}
          </div>
          <div className="absolute inset-0 bg-black bg-opacity-45 z-10" data-id="element-73"></div>
        </div>
        {/* Content */}
        <div className="relative z-20 w-full mx-auto py-8 px-4 sm:px-6 md:px-8 flex flex-col justify-center min-h-[90vh]" data-id="element-74">
          <div className="max-w-3xl mx-auto text-center" data-id="element-75">
            {/* Logo */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7
          }} className="mb-6" data-id="element-76">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iEuzHiZoD7HHWbnpRvvh2M/516lion.png" alt="516 Partners Logo" className="mx-auto w-24 sm:w-28 md:w-32" data-id="element-77" />
            </motion.div>
            {/* Headline Image */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2
          }} className="mb-4" data-id="element-78">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3Uj5sbdkt77G2bAmNr8REV/wallstreetfirepower.png" alt="Wall Street Education, Without Wall Street Fees" className="mx-auto w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg" data-id="element-79" />
            </motion.div>
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.4
          }} className="libre-caslon-text-regular text-base sm:text-lg text-white mb-6 leading-relaxed px-2" data-id="element-80">
              98% of small businesses between $1-20M per year never exit for
              what they are worth. We exist to change that. Watch the video
              below to find out how.
            </motion.p>
            {/* Wistia Video Player */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.6
          }} className="max-w-sm sm:max-w-md md:max-w-xl lg:max-w-2xl mx-auto mb-6" data-id="element-81">
              <div className="relative shadow-2xl rounded-lg overflow-hidden" data-id="element-82">
                <wistia-player media-id="ryfwlsyz5l" aspect="1.900990099009901" data-id="element-83"></wistia-player>
              </div>
            </motion.div>
            {/* Apply button with border light effect */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.8
          }} className="flex justify-center mb-4" data-id="element-84">
              <div className="relative" data-id="element-85">
                <div className="button-border-light" data-id="element-86"></div>
                <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
                scale: 1.05,
                boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
              }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-8 sm:px-10 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-87">
                  Apply for the Challenge Now
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Modal */}
      <AnimatePresence data-id="element-88">
        {isModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90" onClick={() => setIsModalOpen(false)} data-id="element-89">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-4xl h-[90vh] bg-white rounded-lg shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-90">
              <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-colors" data-id="element-91">
                <XIcon size={24} data-id="element-92" />
              </button>
              <iframe src="https://form.typeform.com/to/Z4eXKwXk" className="w-full h-full" frameBorder="0" title="Application Form" data-id="element-93" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};
export default HeroSection;